import { KeyboardOutlined } from "@mui/icons-material";
import { Box, Button, Stack } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";

interface CountButtonProps {
  maxCount?: number | null;
  handleCountSubmit: () => void;
  value?: number;
  backgroundColor?: string;
}

export function CountButton(props: CountButtonProps) {
  const {
    maxCount,
    handleCountSubmit,
    value = 0,
    backgroundColor = "#529FE8",
  } = props;

  return (
    <Button
      id="count-submit-button"  
      data-testid="count-submit-button"
      onClick={handleCountSubmit}
      variant="contained"
      sx={{
        width: "100%",
        height: "34px",
        bgcolor: backgroundColor,
        color: "#FFFFFF",
        justifyContent: "center",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        borderRadius: "17px",
        "& .MuiButton-endIcon": {
          color: "FFFFFF",
        },
        "&:hover": {
          bgcolor: backgroundColor,
          opacity: 0.8,
        },
      }}
      endIcon={
        <Box className="items-center opacity-60 w-[65px] h-full hidden md:flex gap-1">
          <KeyboardOutlined sx={{ height: '24px', width: '24px' }} />
          <Typography variant="small" fontWeight="bold">Enter</Typography>
        </Box>
      }
    >
      <Stack direction="row" spacing="3px">
        <Typography variant="subtitle">
          Submit
        </Typography>
        <Typography variant="subtitle" fontWeight="bold">
          {maxCount && value > maxCount ? `>${maxCount}` : value}
        </Typography>
        <Typography variant="subtitle">
          {value === 1 ? "object" : "objects"}
        </Typography>
      </Stack>
    </Button>
  );
}
